export const NEW = 0;
export const EDIT = 1;
export const DELETE = 2;
export const GET_ALL = 3;
